import Vue from 'vue';
import Router from 'vue-router';

const Page404 = () => import('@/components/views/Page404');
const Page401 = () => import('@/components/views/Page401');
const Nlp = () => import('@/components/views/Nlp');
const Stnk = () => import('@/components/views/Stnk');
// const Nopol = () => import('@/components/views/Nopol');
const Ktp = () => import('@/components/views/Ktp');
const Ktp2 = () => import('@/components/views/Ktp2');
const Pbb = () => import('@/components/views/Pbb');
const Plat = () => import('@/components/views/Plat');
const MyKad = () => import('@/components/views/MyKad');
const MyKadDebug = () => import('@/components/views/MyKadDebug');
const Fiducia = () => import('@/components/views/Fiducia');
const Npwp = () => import('@/components/views/Npwp');
const Sentiment = () => import('@/components/views/Sentiment');
const Handwriting = () => import('@/components/views/Handwriting');
const Ekyc = () => import('@/components/views/Ekyc');

Vue.use(Router);
export default new Router({
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes(){
  return [
    {
      path: '/ekyc',
      name: 'Ekyc',
      component: Ekyc
    },
    {
      path: '/nlp',
      name: 'Nlp',
      component: Nlp
    },
    {
      path: '/stnk',
      name: 'Stnk',
      component: Stnk
    },
    // {
    //   path: '/nopol',
    //   name: 'Nopol',
    //   component: Nopol
    // },
    {
      path: '/',
      name: 'Home',
      component: Ktp
    },
    {
      path: '/ktp',
      name: 'Ktp',
      component: Ktp
    },
    {
      path: '/ktp2',
      name: 'Ktp2',
      component: Ktp2
    },
    {
      path: '/pbb',
      name: 'Pbb',
      component: Pbb
    },
    {
      path: '/plat',
      name: 'Plat',
      component: Plat
    },
    {
      path: '/mykad',
      name: 'Kad Malaysia',
      component: MyKad
    },
    {
      path: '/mykad-debug',
      name: 'Kad Malaysia DEBUG',
      component: MyKadDebug
    },
    {
      path: '/fiducia',
      name: 'Fiducia',
      component: Fiducia
    },
    {
      path: '/npwp',
      name: 'Npwp',
      component: Npwp
    },
    {
      path: '/sentiment',
      name: 'Sentiment',
      component: Sentiment
    },
    {
      path: '/handwriting',
      name: 'Handwriting',
      component: Handwriting
    },
    {
      path: '/401',
      name: 'Page 401',
      component: Page401
    },
    {
      path: '/*',
      name: 'Page 404',
      component: Page404
    }
  ]
}
